import { getAssignedCandidatesInfo } from "./api";

const cache = new Map();

const inFlightRequests = new Map();

const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const createCacheKey = (status, page, size, sortBy, sortDirection) => {
  return `${status || "ALL"}-${page}-${size}-${sortBy}-${sortDirection}`;
};

export const getCachedAssignedCandidates = async (
  status,
  page = 0,
  size = 10,
  sortBy = "candidateId",
  sortDirection = "desc",
) => {
  const cacheKey = createCacheKey(status, page, size, sortBy, sortDirection);

  const cached = cache.get(cacheKey);

  if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
    return cached.data;
  }

  if (inFlightRequests.has(cacheKey)) {
    return inFlightRequests.get(cacheKey);
  }

  const requestPromise = (async () => {
    try {
      const response = await getAssignedCandidatesInfo(
        status,
        page,
        size,
        sortBy,
        sortDirection,
      );

      cache.set(cacheKey, {
        data: response,
        timestamp: Date.now(),
      });

      return response;
    } finally {
      inFlightRequests.delete(cacheKey);
    }
  })();

  inFlightRequests.set(cacheKey, requestPromise);

  return requestPromise;
};

export const refreshAssignedCandidates = async (
  status,
  page = 0,
  size = 10,
  sortBy = "candidateId",
  sortDirection = "desc",
) => {
  const cacheKey = createCacheKey(status, page, size, sortBy, sortDirection);

  const response = await getAssignedCandidatesInfo(
    status,
    page,
    size,
    sortBy,
    sortDirection,
  );

  cache.set(cacheKey, {
    data: response,
    timestamp: Date.now(),
  });

  return response;
};

export const clearAssignedCandidatesCache = (status) => {
  if (status) {
    for (const key of cache.keys()) {
      if (key.startsWith(`${status}-`)) {
        cache.delete(key);
      }
    }

    for (const key of inFlightRequests.keys()) {
      if (key.startsWith(`${status}-`)) {
        inFlightRequests.delete(key);
      }
    }
  } else {
    cache.clear();
    inFlightRequests.clear();
  }
};
